import axios from "axios";
import { checkNestedObject } from "utils/checkNestedObject";
import { GENERIC_ERROR_MESSAGE } from "../Components/Layout/MainContent/DownloadAndDelete/actions/types";

const config = {
  hostURL: window.location.host,
  protocol: window.location.protocol,
  contextRoot: "/privacy/secure/api"
};

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? config.protocol + "//" + config.hostURL + config.contextRoot
      : "http://localhost:8001/privacy/secure/api",
  timeout: 20 * 1000
});

instance.defaults.headers.post["Cache-Control"] = "no-cache, no-store, must-revalidate";
instance.defaults.headers.post["Pragma"] = "no-cache";
instance.defaults.headers.post["Expires"] = 0;
instance.defaults.headers.post["Content-Type"] = "application/json";

instance.interceptors.response.use(response => successHandler(response), error => errorHandler(error));

//instance.interceptors.request.use(config => setCSRFToken(config), error => errorHandler(error));

instance.interceptors.request.use(config => setCustomRequestHeaders(config), error => errorHandler(error));

const updateVzdlOnError = errorVO => {
  if (checkNestedObject(window, "vzdl", "error")) {
    const { vzdl } = window;

    vzdl.error.code = errorVO.errorCode || errorVO.status;
    vzdl.error.message = errorVO.description ? errorVO.description : GENERIC_ERROR_MESSAGE;
  }
};

//Setting up response interceptors.
const successHandler = response => {
  if (
    undefined !== response.data.errorVO &&
    null !== response.data.errorVO &&
    Object.keys(response.data.errorVO).length > 0
  ) {
    const { errorVO } = response.data;

    updateVzdlOnError(errorVO);

    const errorResp = {
      status: errorVO.status,
      response: {
        ...errorVO,
        description: errorVO.description ? errorVO.description : GENERIC_ERROR_MESSAGE
      }
    };
    return Promise.reject(errorResp);
  }

  const res = {
    status: response.data.status,
    data: response.data.responseData
  };
  return Promise.resolve(res);
};

const errorHandler = error => {
  let response = {};

  if (error.code === "ECONNABORTED") {
    response = { description: "API call timeout error" };
  } else {
    const hasErrorVO = checkNestedObject({ ...error }, "response", "data", "errorVO", "description");

    if (hasErrorVO) {
      updateVzdlOnError({ ...error }.response.data.errorVO);
    } else {
      updateVzdlOnError({ ...error }.response);
    }

    if (hasErrorVO && { ...error }.response.data.errorVO.description) {
      response = { ...error.response.data.errorVO };
    } else {
      response = { description: GENERIC_ERROR_MESSAGE };
    }
  }
  return Promise.reject({ response });
};

const setCustomRequestHeaders = config => {
  try {
    config = setCSRFToken(config);
  } catch (e) {}

  try {
    config = setIVRUnregisteredHeaders(config);
  } catch (e) {}

  return config;
};

const setCSRFToken = config => {
  try {
    if (
      null !== document.querySelector('meta[name="csrfToken"]') &&
      null !== document.querySelector('meta[name="csrfToken"]').getAttribute("content")
    ) {
      config.headers["X-CSRF-TOKEN"] = document
        .querySelector('meta[name="csrfToken"]')
        .getAttribute("content"); //window._csrfToken;
    }
  } catch (e) {}
  return config;
};

const setIVRUnregisteredHeaders = config => {
  const { ccpaFlow } = window.reactGlobals;

  try {
    if (ccpaFlow && typeof ccpaFlow === "string") {
      const flowType = ccpaFlow.toLowerCase();

      if (
        flowType === "guest" ||
        flowType === "ivr_unregistered" ||
        flowType === "former" ||
        flowType === "wireline_unregistered"
      ) {
        config.headers["AM_UUID"] = window.reactGlobals.amUUId;
        config.headers["AM_CCPA_FLOW"] = window.reactGlobals.ccpaFlow;
        config.headers["VPD_CCPA_FLOW"] = window.reactGlobals.ccpaFlow;

        config.headers["AM_MOBILE_NUMBER"] = window.reactGlobals.loggedInMdn;
        config.headers["AM_ACCOUNT_NUMBER"] = window.reactGlobals.amAccountNumber;

        // Required for Wireline
        config.headers["AM_VZID"] = window.reactGlobals.amVZId;
        config.headers["AM_COMVZID"] = window.reactGlobals.amComVZId;
      }
    }
  } catch (e) {}
  return config;
};

export const setBaseURLForNonSecure = () => {
  instance.defaults.baseURL =
    process.env.NODE_ENV === "production"
      ? "/privacy/your-data/api"
      : "http://localhost:8001/privacy/secure/api";
};

export const setBaseURLForForceLogout = () => {
  instance.defaults.baseURL =
    process.env.NODE_ENV === "production" ? config.protocol + "//" + config.hostURL : "http://localhost:8001";
};

export default instance;
